import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

type FieldWrapperProps = {
  templateColumns: string
  mediaTemplateColumnsMD: string
}

export const ColumnDivStyled = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const RowDivStyled = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing.lg};
`

export const TitleCol = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};

  #MaterialsInsertTitle {
    font-size: ${theme.typography.sizes.sm};
    font-weight: ${theme.typography.weight.xl};
    color: ${theme.colors.neutral.black};
  }

  #MaterialsInsertSubtitle {
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.xl};
    color: ${theme.colors.neutral.light};
  }
`
export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  grid-gap: ${theme.spacing.sm};
  width: 100%;

  .fieldItemWrapper {
    display: flex;
    flex-direction: column;
  }

  .outerFieldItemWrapper {
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing.lg};
  }
  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    grid-template-columns: ${(props) => props.mediaTemplateColumnsMD};
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: ${theme.spacing.md} 0;
`
